import { downloadById } from '@/api/user';
// 转换字母为汉字
let transfer = function (oldValue,arr) {
    let newValue = '';
    for (let i=0;i<arr.length;i++){
        if (arr[i].value === oldValue) {
            newValue = arr[i].label;
            break;
        }
    }
    return newValue;
};
const downloadOssFile =  (id) => {
    downloadById(id).then(res => {
        download(res);
    });
};
export default {
    transfer,
    downloadOssFile,
    projectTypes: [
        { value: '01', label: '房屋建筑工程' },
        { value: '02', label: '市政公用工程' },
        { value: '03', label: '机电安装工程' },
        { value: '04', label: '铁路工程' },
        { value: '05', label: '公路工程' },
        { value: '06', label: '港口与航道工程' },
        { value: '07', label: '水利水电工程' },
        { value: '08', label: '电力工程' },
        { value: '09', label: '矿山工程' },
        { value: '10', label: '冶炼工程' },
        { value: '11', label: '化工石油工程' },
        { value: '12', label: '通信工程' },
        { value: '99', label: '其他' }
    ],
    prjStatusS: [
        { value: '001', label: '筹备' },
        { value: '002', label: '立项' },
        { value: '003', label: '在建' },
        { value: '004', label: '竣工' },
        { value: '005', label: '停工' },
        { value: '006', label: '完工' }
    ],
    /* 用户类型 */
    userTypes:[
        {
            value:'tenant',
            label:'主管部门',
        },
        {
            value:'sublet',
            label: '企业用户',
        },
        {
            value:'project',
            label: '个人用户',
        },
    ],
    // 获取 idCardNumber
    getIdCardNumber() {
        return localStorage.getItem("idCardNumber");
    },
    // 获取 creditCode
    getCreditCode() {
        return localStorage.getItem("creditCode");
    },
    // 获取 deptName
    getDeptName() {
        return localStorage.getItem("deptName");
    },
    // 获取 tenantAreaCode
    getTenantAreaCode() {
        return localStorage.getItem("tenantAreaCode");
    },
    // 获取 userId
    getUserId() {
        return localStorage.getItem("userId");
    },
    // 获取 userName
    getUserName() {
        return localStorage.getItem("userName");
    },
    // 获取 loginType
    getLoginType() {
        return localStorage.getItem("loginType");
    },
    // 获取当前日期字符串
    getDate() {
        const date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        month = month > 9 ? month : '0' + month;
        day = day > 9 ? day : '0' + day;
        return `${year}-${month}-${day}`;
    },
    timeConvert(timestamp, num) {
        //num:0 YYYY-MM-DD  num:1  YYYY-MM-DD hh:mm:ss // timestamp:时间戳
        timestamp = timestamp + "";
        timestamp = timestamp.length == 10 ? timestamp * 1000 : timestamp;
        var date = new Date(timestamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;
        if (num == 0) {
            return y + "-" + m + "-" + d;
        } else {
            return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
        }
    },
    // 下载文件
    download (response, fileName,type) {
        //application/msword  doc
        //application/vnd.ms-excel
        var blob = new Blob([response.data], {type: type});
        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.target='_blank';
        downloadElement.download = fileName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    }
};
